<template>
  <div class="payment-container">
    <h1>ECPay Integration</h1>
    <h1>ECPay Integration PRO</h1>
    <p>Status: {{ status }}</p>
    <button @click="handlePayment" :disabled="loading" class="pay-btn">
      {{ loading ? 'Connecting to ECPay...' : 'Pay with ECPay' }}
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import api from '@/services/api'
import { logger } from '@myorg/type-lib';

const loading = ref(false);
const status = ref('Ready');

const ECPAY_URL = import.meta.env.VITE_API_ECPAY_URL;
// logger.log("ECPAY_URL",ECPAY_URL)

const handlePayment = async () => {
  loading.value = true;
  status.value = 'Fetching signed data from backend...';

  try {
    // 1. Get signed data using your Axios instance
    // This will now automatically include your Auth tokens via interceptors
    const now = new Date();
    const timestamp = now.getFullYear() +
    String(now.getMonth() + 1).padStart(2, '0') +
    String(now.getDate()).padStart(2, '0') +
    String(now.getHours()).padStart(2, '0') +
    String(now.getMinutes()).padStart(2, '0') +
    String(now.getSeconds()).padStart(2, '0');

    const tradeNo = `NO${timestamp}`;
    const amount = 10 + Math.floor(Math.random() * 5);
    logger.log("tradeNo",tradeNo)
    logger.log("amount",amount)

    // 2. Make the API call with Query Params
    // Axios (and many wrappers) use the 'params' key to build the ?tradeNo=... string
    const response = await api().get('/api/ecpay/checkout', {
        params: {
            amount: amount,
            tradeNo: tradeNo
        }
    });
    
    // Axios puts the JSON body in 'data'
    const params = response.data; 
    
    status.value = 'Redirecting to payment gateway...';
    logger.log("Signed Params:", params);

    // 2. Create dynamic form
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = ECPAY_URL;

    // 3. Add fields as hidden inputs
    Object.keys(params).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = params[key];
      form.appendChild(input);
    });

    // 4. Append to body and submit
    document.body.appendChild(form);
    form.submit();

  } catch (error) {
    logger.error("Payment failed:", error);
    status.value = "Error: " + error.message;
    alert("Could not connect to the payment server.");
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.payment-container { text-align: center; margin-top: 50px; font-family: sans-serif; }
.pay-btn { padding: 10px 20px; font-size: 1.2rem; cursor: pointer; background: #28a745; color: white; border: none; border-radius: 5px; }
.pay-btn:disabled { background: #ccc; }
</style>